import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Table } from 'react-bootstrap';

import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";

import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Loader from "../Loader"
import Message from "../Message"


import { listhomeDetails } from "../../../actions/homeActions";
import { useDispatch, useSelector } from "react-redux";

import menu03 from "../../../images/menus/3.png";
import menu02 from "../../../images/menus/2.png";
import menu01 from "../../../images/menus/1.png";

import testimonial from "../../../images/testimonial/1.jpg";
import testimonial2 from "../../../images/testimonial/2.jpg";
import testimonial3 from "../../../images/testimonial/3.jpg";

import { Dropdown, Tab, Nav } from "react-bootstrap";
import { render } from "react-dom";
import { userDeleteReducer } from "../../../reducers/userReducers";

// import Ext from "../../layouts/Ext";

const ApexLine4 = loadable(() =>
   pMinDelay(import("../charts/apexcharts/Line4"), 500)
);
const ApexNagetivePosative = loadable(() =>
   pMinDelay(import("../charts/apexcharts/NagetivePositive2"), 500)
);
const ApexRedialBar = loadable(() =>
   pMinDelay(import("../charts/apexcharts/RadialBar"), 500)
);

const Home = (props) => {

   const homeDetails = useSelector((state) => state.homeDetails);
   console.log(homeDetails)

   const lastUsers = homeDetails?.home?.last10users;
   const lastShops = homeDetails?.home?.last10shops;

   const dispatch = useDispatch();

   useEffect(() => {
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      console.log(userInfo);
      console.log(props);
      // if(!userInfo){
      //    router

      // }
      dispatch(listhomeDetails());
   }, [dispatch]);

   function SampleNextArrow(props) {
      const { onClick } = props;
      return (
         <div className="owl-next" onClick={onClick} style={{ zIndex: 99 }}>
            <i className="fa fa-caret-right" />
         </div>
      );
   }

   function SamplePrevArrow(props) {
      const { onClick } = props;
      return (
         <div
            className="owl-prev disabled"
            onClick={onClick}
            style={{ zIndex: 99 }}
         >
            <i className="fa fa-caret-left" />
         </div>
      );
   }

   const settings = {
      focusOnSelect: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      speed: 500,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
         {
            breakpoint: 1599,
            settings: {
               slidesToShow: 2,
               slidesToScroll: 1,
            },
         },
         {
            breakpoint: 990,
            settings: {
               slidesToShow: 1,
               slidesToScroll: 1,
            },
         },
      ],
   };


   function usersTableData() {
      if (lastUsers) {
         return lastUsers.map((user) => {
            const { id, email, name } = user
            return (
               <tr key={id}>
                  <td> {id} </td>
                  <td> {email} </td>
                  <td> {name} </td>
               </tr>
            )
         });
      }
   }

   function shopsTableData() {
      if (lastShops) {

         return lastShops.map((shop) => {
            const { id, shop_name_en } = shop
            return (
               <tr key={id}>
                  <td> {id} </td>
                  <td> {shop_name_en} </td>
               </tr>
            )
         });
      }
   }



   return (
      <>{

         homeDetails.loading ? <Loader/> : homeDetails.error ? <Message  variant="danger">{homeDetails.error}</Message>:



            <div>
               <div className="row">
                  {/* { console.log(homeDetails.home.last10users) } */} 
                  <div className="col-xl col-md-6">
                     <div className="card">
                        <div
                           style={{ cursor: "pointer" }}
                           onClick={() => {

                              props.history.replace('/shops/page/1');

                              // /shops/page/1';
                           }}
                        >
                           <div className="card-body p-4">
                              <div className="d-inline-block mb-4 ml--12 position-relative donut-chart-sale">
                                 <span
                                    className="donut1"
                                    data-peity='{ "fill": ["rgb(192, 255, 134)", "rgba(255, 255, 255, 1)"],   "innerRadius": 45, "radius": 10}'
                                    style={{ display: "none" }}
                                 >
                                 </span>
                                 <svg className="peity" height={110} width={110}>
                                    <path
                                       d="M 55 0 A 55 55 0 0 1 55 110 L 55 100 A 45 45 0 0 0 55 10"
                                       data-value={4}
                                       fill="rgb(192, 255, 134)"
                                    />
                                    <path
                                       d="M 55 110 A 55 55 0 0 1 54.99999999999999 0 L 54.99999999999999 10 A 45 45 0 0 0 55 100"
                                       data-value={4}
                                       fill="rgba(255, 255, 255, 1)"
                                    />
                                 </svg>
                                 <small className="text-primary">
                                    <svg
                                       width={40}
                                       height={40}
                                       viewBox="0 0 512 512"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path
                                          d="M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391
                                    v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158
                                    c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747
                                    c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z"
                                          fill="white"
                                       />
                                       <path d="M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401
				                           c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79
				                           c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z"
                                          fill="white" />
                                    </svg>
                                 </small>
                                 <span className="circle bg-primary" />
                              </div>
                              <h2 className="fs-24 text-black font-w600 mb-0">{homeDetails.home.shops}</h2>
                              <span className="fs-14">Shops</span>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-xl col-md-6 col-sm-6">
                     <div className="card">
                        <div
                           style={{ cursor: "pointer" }}
                           onClick={() => {


                              props.history.replace('ecom-product-grid/page/1');


                           }}
                        >
                           <div className="card-body p-4">
                              <div className="d-inline-block mb-4 ml--12 position-relative donut-chart-sale">
                                 <span
                                    className="donut1"
                                    data-peity='{ "fill": ["rgb(255, 195, 210)", "rgba(255, 255, 255, 1)"],   "innerRadius": 45, "radius": 10}'
                                    style={{ display: "none" }}
                                 >
                                 </span>
                                 <svg className="peity" height={110} width={110}>
                                    <path
                                       d="M 55 0 A 55 55 0 0 1 93.89087296526012 93.89087296526012 L 86.81980515339464 86.81980515339464 A 45 45 0 0 0 55 10"
                                       data-value={3}
                                       fill="rgb(255, 195, 210)"
                                    />
                                    <path
                                       d="M 93.89087296526012 93.89087296526012 A 55 55 0 1 1 54.99999999999999 0 L 54.99999999999999 10 A 45 45 0 1 0 86.81980515339464 86.81980515339464"
                                       data-value={5}
                                       fill="rgba(255, 255, 255, 1)"
                                    />
                                 </svg>
                                 <small className="text-primary">
                                    <svg
                                       width={40}
                                       height={40}
                                       viewBox="0 0 512 512"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path d="M452.349,361.2h-17.7V333c0-34.8-28.3-63.2-63.2-63.2s-63.2,28.3-63.2,63.2v28.2h-17.7c-6.6,0-12,5.4-12,12v104.3
                                    c0,6.6,5.4,12,12,12h161.7c6.6,0,12-5.4,12-12V373.2C464.349,366.6,458.949,361.2,452.349,361.2z M332.249,333
                                    c0-21.6,17.6-39.2,39.2-39.2s39.2,17.6,39.2,39.2v28.2h-78.3V333H332.249z M440.349,465.5h-137.7v-80.3h137.7L440.349,465.5
                                    L440.349,465.5z"
                                          fill="white" />
                                       <path d="M288.949,165.8c6.6,0,12-5.4,12-12v-39.7h44.4l10.6,119.4c0.6,6.6,6.4,11.5,13,10.9s11.5-6.4,10.9-13l-11.6-130.3
                                    c-0.5-6.2-5.7-10.9-12-10.9h-55.4c-0.4-49.8-41-90.2-90.9-90.2s-90.5,40.4-90.9,90.2h-55.3c-6.2,0-11.4,4.7-12,10.9l-26.5,299.1
                                    c0,0.4,0,0.7,0,1.1c0,33.6,30.9,61,68.8,61h151.1c6.6,0,12-5.4,12-12s-5.4-12-12-12h-151.1c-24.5,0-44.5-16.3-44.8-36.5
                                    l25.5-287.7h44.4v39.7c0,6.6,5.4,12,12,12c6.6,0,12-5.4,12-12v-39.7h133.8v39.7C276.949,160.4,282.349,165.8,288.949,165.8z
                                    M210.049,23.9c36.7,0,66.5,29.7,66.9,66.2h-133.8C143.549,53.6,173.349,23.9,210.049,23.9z"
                                          fill="white" />
                                    </svg>
                                 </small>
                                 <span className="circle bg-danger" />
                              </div>
                              <h2 className="fs-24 text-black font-w600 mb-0">{homeDetails.home.products}</h2>
                              <span className="fs-14">Products</span>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-xl col-md-4 col-sm-6">
                     <div className="card">
                        <div
                           style={{ cursor: "pointer" }}
                           onClick={() => {

                              props.history.replace('/orders/page/1');

                           }}
                        >
                           <div className="card-body p-4">
                              <div className="d-inline-block mb-4 ml--12 position-relative donut-chart-sale">
                                 <span
                                    className="donut1"
                                    data-peity='{ "fill": ["rgb(255, 213, 174)", "rgba(255, 255, 255, 1)"],   "innerRadius": 45, "radius": 10}'
                                    style={{ display: "none" }}
                                 >
                                    5/8
                           </span>
                                 <svg className="peity" height={110} width={110}>
                                    <path
                                       d="M 55 0 A 55 55 0 1 1 16.109127034739892 93.89087296526012 L 23.180194846605364 86.81980515339464 A 45 45 0 1 0 55 10"
                                       data-value={5}
                                       fill="rgb(255, 213, 174)"
                                    />
                                    <path
                                       d="M 16.109127034739892 93.89087296526012 A 55 55 0 0 1 54.99999999999999 0 L 54.99999999999999 10 A 45 45 0 0 0 23.180194846605364 86.81980515339464"
                                       data-value={3}
                                       fill="rgba(255, 255, 255, 1)"
                                    />
                                 </svg>
                                 <small className="text-primary">
                                    <svg
                                       width={40}
                                       height={40}
                                       viewBox="0 0 512 512"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path d="M441.928,118.601H108.43L86.037,37.952c-2.403-8.657-10.285-14.649-19.271-14.649H20c-11.046,0-20,8.954-20,20
                                       c0,11.046,8.954,20,20,20h31.563l88.086,317.243c2.403,8.657,10.285,14.649,19.271,14.649h4.584
                                       c-0.772,2.865-1.19,5.874-1.19,8.982c0,19.025,15.423,34.448,34.448,34.448c19.025,0,34.449-15.423,34.449-34.448
                                       c0-3.108-0.419-6.117-1.19-8.982h42.435c-0.772,2.865-1.19,5.874-1.19,8.982c0,19.025,15.423,34.448,34.448,34.448
                                       c19.025,0,34.448-15.423,34.448-34.448c0-3.108-0.418-6.117-1.19-8.982h17.447c11.046,0,20-8.954,20-20c0-11.046-8.954-20-20-20
                                       H174.123l-8.575-30.882h206.308c12.066,0,22.627-8.109,25.741-19.767l38.987-145.944h5.343c11.046,0,20-8.954,20-20
                                       C461.927,127.556,452.974,118.601,441.928,118.601z M211.762,269.506c0,8.284-6.716,15-15,15s-15-6.716-15-15v-85.129
                                       c0-8.284,6.716-15,15-15s15,6.716,15,15V269.506z M283.462,269.506c0,8.284-6.716,15-15,15s-15-6.716-15-15v-85.129
                                       c0-8.284,6.716-15,15-15s15,6.716,15,15V269.506z M355.161,269.506c0,8.284-6.716,15-15,15s-15-6.716-15-15v-85.129
                                       c0-8.284,6.716-15,15-15s15,6.716,15,15V269.506z"
                                          fill="white" />
                                    </svg>
                                 </small>
                                 <span className="circle bg-warning" />
                              </div>
                              <h2 className="fs-24 text-black font-w600 mb-0">{homeDetails.home.orders}</h2>
                              <span className="fs-14">Orders</span>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-xl col-md-4 col-sm-6">
                     <div className="card">
                        <div
                           style={{ cursor: "pointer" }}
                           onClick={() => {
                              props.history.replace('/usersList/page/1');


                           }}
                        >
                           <div className="card-body p-4">
                              <div className="d-inline-block mb-4 ml--12 position-relative donut-chart-sale">
                                 <span
                                    className="donut1"
                                    data-peity='{ "fill": ["rgb(238, 252, 255)", "rgba(255, 255, 255, 1)"],   "innerRadius": 45, "radius": 10}'
                                    style={{ display: "none" }}
                                 >
                                    8/8
                           </span>
                                 <svg className="peity" height={110} width={110}>
                                    <path
                                       d="M 55 0 A 55 55 0 1 1 54.99 0 L 54.99 10 A 45 45 0 1 0 55 10"
                                       data-value={8}
                                       fill="rgb(238, 252, 255)"
                                    />
                                 </svg>
                                 <small className="text-primary">
                                    <svg
                                       width={40}
                                       height={40}
                                       viewBox="0 0 512 512"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path id="XMLID_1718_" d="M442.7,444.6c-14.3-96.2-51.6-191-139.6-221.4C337.3,201.9,360,164,360,120.7C360,54.1,306,0,239.3,0
                                       S118.6,54,118.6,120.7c0,43.2,22.8,81.2,56.9,102.5c-88,30.4-125.4,125.2-139.6,221.4c-2.7,17.9,11.4,34,29.5,34H413
                                       C431.3,478.6,445.4,462.5,442.7,444.6z M164.1,120.7c0-41.5,33.8-75.3,75.3-75.3c9.9,0,18,8.1,18,18s-8.1,18-18,18
                                       c-21.7,0-39.3,17.6-39.3,39.3c0,9.9-8.1,18-18,18C172.1,138.7,164.1,130.7,164.1,120.7z"
                                          fill="white" />
                                    </svg>
                                 </small>
                                 <span className="circle bg-info" />
                              </div>
                              <h2 className="fs-24 text-black font-w600 mb-0">
                                 {homeDetails.home.users}
                              </h2>
                              <span className="fs-14">Users</span>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               {/* {console.log(homeDetails.home.pendingorders)} */}





               {/* <div className="col-xl col-md-4 col-sm-6">
               <div className="card">
                  <div className="card-body p-4">
                     <div className="d-inline-block mb-4 ml--12 position-relative donut-chart-sale">
                        <span
                           className="donut1"
                           data-peity='{ "fill": ["rgb(242, 255, 253)", "rgba(255, 255, 255, 1)"],   "innerRadius": 45, "radius": 10}'
                           style={{ display: "none" }}
                        >
                           8/8
                        </span>
                        <svg className="peity" height={110} width={110}>
                           <path
                              d="M 55 0 A 55 55 0 1 1 54.99 0 L 54.99 10 A 45 45 0 1 0 55 10"
                              data-value={8}
                              fill="rgb(242, 255, 253)"
                           />
                        </svg>
                        <small className="text-primary">
                           <svg
                              width={40}
                              height={40}
                              viewBox="0 0 40 40"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                           >
                              <path
                                 d="M26.1666 19.5283C27.8064 18.2461 29.0052 16.484 29.5958 14.4879C30.1863 12.4919 30.1393 10.3612 29.4611 8.39317C28.783 6.4251 27.5076 4.71772 25.8128 3.5091C24.118 2.30048 22.0883 1.65088 20.0066 1.65088C17.925 1.65088 15.8953 2.30048 14.2005 3.5091C12.5057 4.71772 11.2303 6.4251 10.5522 8.39317C9.87403 10.3612 9.82697 12.4919 10.4175 14.4879C11.0081 16.484 12.2069 18.2461 13.8466 19.5283C10.7486 20.761 8.09109 22.8939 6.21709 25.6517C4.34309 28.4096 3.33862 31.6657 3.33331 35V36.6667C3.33331 37.1087 3.50891 37.5326 3.82147 37.8452C4.13403 38.1577 4.55795 38.3333 4.99998 38.3333H35C35.442 38.3333 35.8659 38.1577 36.1785 37.8452C36.4911 37.5326 36.6666 37.1087 36.6666 36.6667V35C36.6624 31.6673 35.6599 28.4122 33.7884 25.6546C31.9169 22.8969 29.2622 20.7631 26.1666 19.5283ZM13.3333 11.6667C13.3333 10.3481 13.7243 9.0592 14.4569 7.96287C15.1894 6.86654 16.2306 6.01206 17.4488 5.50748C18.6669 5.00289 20.0074 4.87087 21.3006 5.12811C22.5938 5.38534 23.7817 6.02028 24.714 6.95263C25.6464 7.88498 26.2813 9.07286 26.5385 10.3661C26.7958 11.6593 26.6638 12.9997 26.1592 14.2179C25.6546 15.4361 24.8001 16.4773 23.7038 17.2098C22.6075 17.9423 21.3185 18.3333 20 18.3333C18.2319 18.3333 16.5362 17.631 15.2859 16.3807C14.0357 15.1305 13.3333 13.4348 13.3333 11.6667ZM6.66665 35C6.66665 31.4638 8.0714 28.0724 10.5719 25.5719C13.0724 23.0714 16.4638 21.6667 20 21.6667C23.5362 21.6667 26.9276 23.0714 29.4281 25.5719C31.9286 28.0724 33.3333 31.4638 33.3333 35H6.66665Z"
                                 fill="white"
                              />
                           </svg>
                        </small>
                        <span className="circle bg-success" />
                     </div>
                     <h2 className="fs-24 text-black font-w600 mb-0">
                        97 Person
                     </h2>
                     <span className="fs-14">Total Members</span>
                  </div>
               </div>
            </div> */}


               {/* <div className="col-xl-9 col-xxl-8"> */}
               <div className="row">
                  <div className="col-xl col-md-6">
                     <div className="card">
                        <div
                           style={{ cursor: "pointer" }}
                           onClick={() => {
                              props.history.replace('/orders/page/1');


                           }}
                        >
                           <div className="card-body p-4">
                              <div className="d-inline-block mb-4 ml--12 position-relative donut-chart-sale">
                                 {/* <span
                           className="donut1"
                           data-peity='{ "fill": ["rgb(192, 255, 134)", "rgba(255, 255, 255, 1)"],   "innerRadius": 45, "radius": 10}'
                           style={{ display: "none" }}
                        >
                           4/8
                        </span> */}
                                 <svg className="peity" height={110} width={110}>
                                    <path
                                       d="M 55 0 A 55 55 0 0 1 55 110 L 55 100 A 45 45 0 0 0 55 10"
                                       data-value={4}
                                       fill="rgb(255, 185, 90)"
                                    />
                                    <path
                                       d="M 55 110 A 55 55 0 0 1 54.99999999999999 0 L 54.99999999999999 10 A 45 45 0 0 0 55 100"
                                       data-value={4}
                                       fill="rgba(255, 255, 255, 1)"
                                    />
                                 </svg>
                                 <small className="text-primary">
                                    <svg
                                       width={40}
                                       height={40}
                                       viewBox="0 0 25 25"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path d="M6.5,12 C9.53756612,12 12,14.4624339 12,17.5 C12,20.5375661 9.53756612,23 6.5,23 C3.46243388,23 1,20.5375661 1,17.5 C1,14.4624339 3.46243388,12 6.5,12 Z M6.5,19.88 C6.15509206,19.88 5.87548893,20.1596031 5.87548893,20.5045111 C5.87548893,20.849419 6.15509206,21.1290221 6.5,21.1290221 C6.84490794,21.1290221 7.12451107,20.849419 7.12451107,20.5045111 C7.12451107,20.1596031 6.84490794,19.88 6.5,19.88 Z M17.75,3 C19.5449254,3 21,4.45507456 21,6.25 L21,17.75 C21,19.5449254 19.5449254,21 17.75,21 L11.9774077,21.0012092 C12.2742498,20.5377831 12.5138894,20.0341997 12.6863646,19.5004209 L17.75,19.5 C18.7164983,19.5 19.5,18.7164983 19.5,17.75 L19.5,6.25 C19.5,5.28350169 18.7164983,4.5 17.75,4.5 L6.25,4.5 C5.28350169,4.5 4.5,5.28350169 4.5,6.25 L4.49957906,11.3136354 C3.96580034,11.4861106 3.46221691,11.7257502 2.99879075,12.0225923 L3,6.25 C3,4.45507456 4.45507456,3 6.25,3 L17.75,3 Z M6.5000438,14.0030924 C5.45209485,14.0030924 4.63575024,14.8204841 4.64666418,15.9573825 C4.64931495,16.2335122 4.87531114,16.4552106 5.15144079,16.4525598 C5.42757044,16.449909 5.64926888,16.2239129 5.6466181,15.9477832 C5.64105975,15.3687734 6.00627225,15.0030924 6.5000438,15.0030924 C6.97241724,15.0030924 7.35344646,15.3949794 7.35344646,15.9525829 C7.35344646,16.1768805 7.27815856,16.343747 7.03551615,16.6299729 L6.93650069,16.7432479 L6.67112833,17.0333231 C6.18682267,17.5748716 6.0000438,17.9254825 6.0000438,18.5006005 C6.0000438,18.7767429 6.22390142,19.0006005 6.5000438,19.0006005 C6.77618617,19.0006005 7.0000438,18.7767429 7.0000438,18.5006005 C7.0000438,18.268353 7.07645293,18.0980788 7.32379001,17.8062547 L7.42473827,17.6907646 L7.69048308,17.400276 C8.16815154,16.8660369 8.35344646,16.5185919 8.35344646,15.9525829 C8.35344646,14.8488849 7.5310877,14.0030924 6.5000438,14.0030924 Z M11.75,6 C12.1296958,6 12.443491,6.28215388 12.4931534,6.64822944 L12.5,6.75 L12.5,12 L16.2482627,12 C16.6624763,12 16.9982627,12.3357864 16.9982627,12.75 C16.9982627,13.1296958 16.7161089,13.443491 16.3500333,13.4931534 L16.2482627,13.5 L11.75,13.5 C11.3703042,13.5 11.056509,13.2178461 11.0068466,12.8517706 L11,12.75 L11,6.75 C11,6.33578644 11.3357864,6 11.75,6 Z" fill="white" />
                                    </svg>
                                 </small>
                                 <span className=" circle bg-warning" />
                              </div>
                              <h2 className="fs-24 text-black font-w600 mb-0">{homeDetails.home.pendingorders}</h2>
                              <span className="fs-14">Pending Orders</span>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-xl col-md-6 col-sm-6">
                     <div className="card">
                        <div
                           style={{ cursor: "pointer" }}
                           onClick={() => {

                              props.history.replace('/orders/page/1');


                           }}
                        >
                           <div className="card-body p-4">
                              <div className="d-inline-block mb-4 ml--12 position-relative donut-chart-sale">
                                 <span
                                    className="donut1"
                                    data-peity='{ "fill": ["rgb(255, 195, 210)", "rgba(255, 255, 255, 1)"],   "innerRadius": 45, "radius": 10}'
                                    style={{ display: "none" }}
                                 >
                                    3/8
                        </span>
                                 <svg className="peity" height={110} width={110}>
                                    <path
                                       d="M 55 0 A 55 55 0 0 1 93.89087296526012 93.89087296526012 L 86.81980515339464 86.81980515339464 A 45 45 0 0 0 55 10"
                                       data-value={3}
                                       fill="rgb(146, 228, 228)"
                                    />
                                    {/* <path
                              d="M 93.89087296526012 93.89087296526012 A 55 55 0 1 1 54.99999999999999 0 L 54.99999999999999 10 A 45 45 0 1 0 86.81980515339464 86.81980515339464"
                              data-value={5}
                              fill="rgba(255, 255, 255, 1)"
                           /> */}
                                 </svg>
                                 <small className="text-primary">
                                    <svg
                                       width={40}
                                       height={40}
                                       viewBox="0 0 512 512"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path d="M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.615,256-256S397.385,0,256,0z M386.594,226.664
                                          L252.747,360.511c-7.551,7.551-17.795,11.794-28.475,11.794s-20.923-4.243-28.475-11.795l-70.388-70.389
                                          c-15.726-15.726-15.726-41.223,0.001-56.95c15.727-15.725,41.224-15.726,56.95,0.001l41.913,41.915l105.371-105.371
                                          c15.727-15.726,41.223-15.726,56.951,0.001C402.319,185.44,402.319,210.938,386.594,226.664z"
                                          fill="white" />
                                    </svg>
                                 </small>
                                 <span className="circle bg-success" />
                              </div>
                              <h2 className="fs-24 text-black font-w600 mb-0">{homeDetails.home.confirmedorders}</h2>
                              <span className="fs-14">Confirmed Orders</span>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-xl col-md-4 col-sm-6">
                     <div className="card">
                        <div
                           style={{ cursor: "pointer" }}
                           onClick={() => {
                              props.history.replace('/orders/page/1');

                              

                           }}
                        >
                           <div className="card-body p-4">
                              <div className="d-inline-block mb-4 ml--12 position-relative donut-chart-sale">
                                 <span
                                    className="donut1"
                                    data-peity='{ "fill": ["rgb(255, 213, 174)", "rgba(255, 255, 255, 1)"],   "innerRadius": 45, "radius": 10}'
                                    style={{ display: "none" }}
                                 >
                                    5/8
                        </span>
                                 <svg className="peity" height={110} width={110}>
                                    <path
                                       d="M 55 0 A 55 55 0 1 1 16.109127034739892 93.89087296526012 L 23.180194846605364 86.81980515339464 A 45 45 0 1 0 55 10"
                                       data-value={5}
                                       fill="rgb(245, 154, 168)"
                                    />
                                    <path
                                       d="M 16.109127034739892 93.89087296526012 A 55 55 0 0 1 54.99999999999999 0 L 54.99999999999999 10 A 45 45 0 0 0 23.180194846605364 86.81980515339464"
                                       data-value={3}
                                       fill="rgba(255, 255, 255, 1)"
                                    />
                                 </svg>
                                 <small className="text-primary">
                                    <svg
                                       width={40}
                                       height={40}
                                       viewBox="0 0 55 55"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path
                                          d="M44.373,7.603c-10.137-10.137-26.632-10.138-36.77,0c-10.138,10.138-10.137,26.632,0,36.77s26.632,10.138,36.77,0
                                    C54.51,34.235,54.51,17.74,44.373,7.603z M36.241,36.241c-0.781,0.781-2.047,0.781-2.828,0l-7.425-7.425l-7.778,7.778
                                    c-0.781,0.781-2.047,0.781-2.828,0c-0.781-0.781-0.781-2.047,0-2.828l7.778-7.778l-7.425-7.425c-0.781-0.781-0.781-2.048,0-2.828
                                    c0.781-0.781,2.047-0.781,2.828,0l7.425,7.425l7.071-7.071c0.781-0.781,2.047-0.781,2.828,0c0.781,0.781,0.781,2.047,0,2.828
                                    l-7.071,7.071l7.425,7.425C37.022,34.194,37.022,35.46,36.241,36.241z"
                                          fill="white"
                                       />
                                    </svg>
                                 </small>
                                 <span className="circle bg-danger" />
                              </div>
                              <h2 className="fs-24 text-black font-w600 mb-0">{homeDetails.home.cancelledorders}</h2>
                              <span className="fs-14">Cancelled Orders</span>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-xl col-md-4 col-sm-6">
                     <div className="card">
                        <div
                           style={{ cursor: "pointer" }}
                           onClick={() => {
                              props.history.replace('/orders/page/1');
                           
                           }}
                        >
                           <div className="card-body p-4">
                              <div className="d-inline-block mb-4 ml--12 position-relative donut-chart-sale">
                                 <span
                                    className="donut1"
                                    data-peity='{ "fill": ["rgb(238, 252, 255)", "rgba(255, 255, 255, 1)"],   "innerRadius": 45, "radius": 10}'
                                    style={{ display: "none" }}
                                 >
                                    8/8
                        </span>
                                 <svg className="peity" height={110} width={110}>
                                    <path
                                       d="M 55 0 A 55 55 0 1 1 54.99 0 L 54.99 10 A 45 45 0 1 0 55 10"
                                       data-value={8}
                                       fill="rgb(133, 200, 208)"
                                    />
                                 </svg>
                                 <small className="text-primary">
                                    <svg
                                       width={40}
                                       height={40}
                                       viewBox="0 0 512 512"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path d="M83.478,139.13H16.696C7.479,139.13,0,146.603,0,155.826v333.913c0,9.223,7.479,16.696,16.696,16.696h66.783
                                       c9.217,0,16.696-7.473,16.696-16.696V155.826C100.174,146.603,92.695,139.13,83.478,139.13z M50.089,439.652
                                       c-9.212,0-16.696-7.484-16.696-16.696s7.484-16.696,16.696-16.696s16.696,7.484,16.696,16.696S59.302,439.652,50.089,439.652z"
                                          fill="white" />
                                       <path d="M512,222.609c0-27.619-22.468-50.087-50.087-50.087H334.054c21.989-51.386,18.391-114.603,18.228-116.87
                                       c0-27.619-22.468-50.087-50.087-50.087s-50.087,22.468-50.087,50.087c0,44.07-26.75,84.749-66.554,101.222l-41.673,17.233
                                       c-6.24,2.581-10.316,8.674-10.316,15.429v266.81c0,9.223,7.479,16.696,16.696,16.696h211.478
                                       c27.619,0,50.087-22.468,50.087-50.087c0-6.511-1.25-12.739-3.522-18.451c21.25-5.799,36.913-25.272,36.913-48.332
                                       c0-6.511-1.25-12.739-3.522-18.451c21.25-5.799,36.913-25.272,36.913-48.332c0-6.511-1.25-12.739-3.522-18.45
                                       C496.337,265.142,512,245.669,512,222.609z"
                                          fill="white" />
                                    </svg>
                                 </small>
                                 <span className="circle bg-info" />
                              </div>
                              <h2 className="fs-24 text-black font-w600 mb-0">
                                 {homeDetails.home.deliveredorders}
                              </h2>
                              <span className="fs-14">Delivered Orders</span>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-xl col-md-6">
                     <div className="card">
                        <div
                           style={{ cursor: "pointer" }}
                           onClick={() => {
                              props.history.replace('/orders/page/1');


                  
                           }}
                        >
                           <div className="card-body p-4">
                              <div className="d-inline-block mb-4 ml--12 position-relative donut-chart-sale">
                                 <span
                                    className="donut1"
                                    data-peity='{ "fill": ["rgb(192, 255, 134)", "rgba(255, 255, 255, 1)"],   "innerRadius": 45, "radius": 10}'
                                    style={{ display: "none" }}
                                 >
                                    4/8
                        </span>
                                 <svg className="peity" height={110} width={110}>
                                    <path
                                       d="M 55 0 A 55 55 0 0 1 55 110 L 55 100 A 45 45 0 0 0 55 10"
                                       data-value={4}
                                       fill="rgb(194, 150, 214)"
                                    />
                                    <path
                                       d="M 55 110 A 55 55 0 0 1 54.99999999999999 0 L 54.99999999999999 10 A 45 45 0 0 0 55 100"
                                       data-value={4}
                                       fill="rgba(255, 255, 255, 1)"
                                    />
                                 </svg>
                                 <small className="text-primary">
                                    <svg
                                       width={40}
                                       height={40}
                                       viewBox="0 0 512 512"
                                       fill="none"
                                       xmlns="http://www.w3.org/2000/svg"
                                    >
                                       <path d="M117.333,10.667h-64C23.936,10.667,0,34.603,0,64v170.667C0,264.064,23.936,288,53.333,288H160
                                    c5.888,0,10.667-4.779,10.667-10.667V64C170.667,34.603,146.731,10.667,117.333,10.667z"
                                          fill="white" />
                                       <path d="M512,208c0-18.496-10.603-34.731-26.347-42.667c3.285-6.549,5.013-13.781,5.013-21.333
                                    c0-18.496-10.603-34.752-26.368-42.688c4.864-9.728,6.293-20.928,3.84-32.043C463.36,47.68,443.051,32,419.819,32H224
                                    c-7.232,0-16.405,1.173-25.771,3.285c-5.739,1.301-9.344,6.976-8.064,12.693C191.403,53.632,192,58.859,192,64v213.333
                                    c0,5.739-1.6,11.264-4.736,16.448c-1.835,3.029-2.048,6.763-0.555,9.984l47.957,103.893v72.32c0,3.243,1.472,6.293,3.989,8.341
                                    c0.683,0.555,16.512,13.013,38.677,13.013c24.683,0,64-39.061,64-85.333c0-29.184-10.453-65.515-16.96-85.333h131.755
                                    c28.715,0,53.141-21.248,55.637-48.341c1.387-15.189-3.669-29.824-13.632-40.725C506.901,232.768,512,220.821,512,208z"
                                          fill="white" />
                                    </svg>
                                 </small>
                                 <span className="circle bg-secondary" />
                              </div>
                              <h2 className="fs-24 text-black font-w600 mb-0">{homeDetails.home.rejectedorders}</h2>
                              <span className="fs-14">Rejected Orders</span>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="row">
                  <div className="col-xl-5 col-md-6 mr-5 ml-5">
                     <h4> Recently Created Accounts </h4>
                     <div>
                        <div
                           style={{ cursor: "pointer" }}
                           onClick={() => {
                              props.history.replace('/usersList/page/1');


                          
                           }}
                        >  
                           <Table>
                              <thead>
                                 <tr>
                                    <th> id </th>
                                    <th> email </th>
                                    <th> name </th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {usersTableData()}
                              </tbody>
                           </Table>
                        </div>
                     </div>
                  </div>

                  <div className="col-xl-5 col-md-6 ml-5">
                     <h4> Recently Created Shops </h4>
                     <div>
                        <div
                           style={{ cursor: "pointer" }}
                           onClick={() => {
                              props.history.replace('/shops/page/1');
                           }}
                        >
                           <Table>
                              <thead>
                                 <tr>
                                    <th> id </th>
                                    <th> shop name </th>
                                 </tr>
                              </thead>
                              <tbody>
                                 {shopsTableData()}
                              </tbody>
                           </Table>
                        </div>
                     </div>
                  </div>
               </div>


               {/* <div className="card">
                  <div className="card-header flex-wrap pb-0 border-0">
                     <div className="mr-auto pr-3 mb-2">
                        <h4 className="text-black fs-20">Workout Statistic</h4>
                        <p className="fs-13 mb-2 mb-sm-0 text-black">
                           Lorem ipsum dolor sit amet, consectetur
                        </p>
                     </div>
                     <div className="d-flex mr-3 mr-sm-5 mb-2">
                        <svg
                           className="mr-2 mt-1"
                           width={24}
                           height={24}
                           viewBox="0 0 24 24"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <g clipPath="url(#clip4)">
                              <path
                                 d="M0.988941 17.074C0.32826 17.2006 -0.1046 17.8385 0.021967 18.4992C0.133346 19.0814 0.644678 19.4864 1.21676 19.4864C1.2927 19.4864 1.37117 19.4788 1.44712 19.4636L6.45918 18.5017C6.74522 18.446 7.00089 18.2916 7.18315 18.0638L9.33479 15.3502L8.61591 14.9832C8.08433 14.7148 7.71473 14.2288 7.58816 13.639L5.55802 16.1982L0.988941 17.074Z"
                                 fill="#FF9432"
                              />
                              <path
                                 d="M18.84 6.493C20.3135 6.493 21.508 5.29848 21.508 3.82496C21.508 2.35144 20.3135 1.15692 18.84 1.15692C17.3664 1.15692 16.1719 2.35144 16.1719 3.82496C16.1719 5.29848 17.3664 6.493 18.84 6.493Z"
                                 fill="#FF9432"
                              />
                              <path
                                 d="M13.0179 3.15671C12.7369 2.86813 12.4762 2.75422 12.1902 2.75422C12.0864 2.75422 11.9826 2.76941 11.8712 2.79472L7.29202 3.88067C6.65918 4.03002 6.26936 4.66539 6.4187 5.29569C6.5478 5.8374 7.02876 6.20192 7.56287 6.20192C7.65403 6.20192 7.74513 6.19179 7.83628 6.16901L11.7371 5.24507C11.9902 5.52605 13.2584 6.90057 13.4888 7.14358C11.8763 8.86996 10.2638 10.5938 8.65135 12.3202C8.62604 12.3481 8.60328 12.3759 8.58047 12.4037C8.10964 13.0036 8.25395 13.9453 8.96273 14.3022L13.9064 16.826L11.3396 20.985C10.9878 21.5571 11.165 22.3063 11.7371 22.6607C11.937 22.7848 12.1573 22.843 12.375 22.843C12.7825 22.843 13.1824 22.638 13.4128 22.2658L16.6732 16.9829C16.8529 16.6918 16.901 16.34 16.8073 16.0134C16.7137 15.6843 16.4884 15.411 16.1821 15.2565L12.8331 13.5529L16.3543 9.7863L19.0122 12.0392C19.2324 12.2265 19.5032 12.3176 19.7716 12.3176C20.0601 12.3176 20.3487 12.2113 20.574 12.0038L23.6243 9.16106C24.1002 8.71808 24.128 7.97386 23.685 7.49797C23.4521 7.24989 23.1382 7.12333 22.8243 7.12333C22.5383 7.12333 22.2497 7.22711 22.0244 7.43721L19.7412 9.56101C19.7386 9.56354 14.0178 4.1819 13.0179 3.15671Z"
                                 fill="#FF9432"
                              />
                           </g>
                           <defs>
                              <clipPath id="clip4">
                                 <rect width={24} height={24} fill="white" />
                              </clipPath>
                           </defs>
                        </svg>
                        <div>
                           <h4 className="fs-18 text-black font-w600 mb-0">
                              45%
                           </h4>
                           <span className="fs-12 text-black">Running</span>
                        </div>
                     </div>
                     <div className="d-flex mr-3 mr-sm-5 mb-2">
                        <svg
                           className="mr-2 mt-1"
                           width={24}
                           height={24}
                           viewBox="0 0 24 24"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <path
                              d="M10.8586 5.22599L5.87121 10.5543C5.50758 11.0846 5.64394 11.8068 6.17172 12.1679L11.1945 15.6098V18.9558C11.1945 19.5921 11.6995 20.125 12.3359 20.1376C12.9874 20.1477 13.5177 19.625 13.5177 18.976V15.0013C13.5177 14.6174 13.3283 14.2588 13.0126 14.0442L9.79041 11.8346L12.5025 8.95836L13.8914 12.1225C14.0758 12.5442 14.4949 12.817 14.9546 12.817H19.1844C19.8207 12.817 20.3536 12.3119 20.3662 11.6755C20.3763 11.024 19.8536 10.4937 19.2046 10.4937H15.7172C15.2576 9.44824 14.7677 8.41288 14.3409 7.35228C14.1237 6.81693 14.0025 6.5846 13.6036 6.21592C13.5227 6.14016 12.9596 5.62501 12.4571 5.16541C11.995 4.74619 11.2828 4.77397 10.8586 5.22599Z"
                              fill="#1EA7C5"
                           />
                           <path
                              d="M15.6162 5.80681C17.0861 5.80681 18.2778 4.61517 18.2778 3.1452C18.2778 1.67523 17.0861 0.483582 15.6162 0.483582C14.1462 0.483582 12.9545 1.67523 12.9545 3.1452C12.9545 4.61517 14.1462 5.80681 15.6162 5.80681Z"
                              fill="#1EA7C5"
                           />
                           <path
                              d="M4.89899 23.5164C7.60463 23.5164 9.79798 21.3231 9.79798 18.6174C9.79798 15.9118 7.60463 13.7184 4.89899 13.7184C2.19335 13.7184 0 15.9118 0 18.6174C0 21.3231 2.19335 23.5164 4.89899 23.5164Z"
                              fill="#1EA7C5"
                           />
                           <path
                              d="M19.101 23.5164C21.8066 23.5164 24 21.3231 24 18.6174C24 15.9118 21.8066 13.7184 19.101 13.7184C16.3954 13.7184 14.202 15.9118 14.202 18.6174C14.202 21.3231 16.3954 23.5164 19.101 23.5164Z"
                              fill="#1EA7C5"
                           />
                        </svg>
                        <div>
                           <h4 className="fs-18 text-black font-w600 mb-0">
                              27%
                           </h4>
                           <span className="fs-12 text-black">Cycling</span>
                        </div>
                     </div>
                     <div className="d-flex mr-3 mr-sm-5 mb-2">
                        <svg
                           className="mr-2 mt-1"
                           width={24}
                           height={24}
                           viewBox="0 0 24 24"
                           fill="none"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <g clipPath="url(#clip5)">
                              <path
                                 d="M11.9997 5.9999C13.6566 5.9999 14.9997 4.65677 14.9997 2.99995C14.9997 1.34312 13.6566 0 11.9997 0C10.3429 0 8.9998 1.34312 8.9998 2.99995C8.9998 4.65677 10.3429 5.9999 11.9997 5.9999Z"
                                 fill="#C046D3"
                              />
                              <path
                                 d="M17.8305 21.8297L14.1361 23.2153L15.9733 23.9042C16.764 24.1978 17.6171 23.791 17.9046 23.0261C18.0577 22.618 18.0124 22.1905 17.8305 21.8297Z"
                                 fill="#C046D3"
                              />
                              <path
                                 d="M5.02677 16.5949C4.25263 16.3078 3.3869 16.6974 3.09543 17.473C2.80467 18.2486 3.19799 19.1128 3.97354 19.4043L5.5918 20.0111L9.86412 18.4088L5.02677 16.5949Z"
                                 fill="#C046D3"
                              />
                              <path
                                 d="M20.9045 17.473C20.613 16.6974 19.7473 16.3078 18.9732 16.5949L6.97345 21.0948C6.19781 21.3863 5.80453 22.2505 6.0953 23.0262C6.38278 23.7908 7.23572 24.198 8.02664 23.9043L20.0264 19.4044C20.8021 19.1129 21.1953 18.2487 20.9045 17.473Z"
                                 fill="#C046D3"
                              />
                              <path
                                 d="M22.4998 11.9998H18.9271L16.3417 6.82899C16.073 6.29213 15.5265 5.98627 14.9632 5.99991L11.9997 5.9999L9.03663 5.99991C8.47343 5.98627 7.92757 6.29217 7.65828 6.82899L5.07289 11.9998H1.50022C0.671898 11.9998 0.000274658 12.6714 0.000274658 13.4997C0.000274658 14.328 0.671898 14.9997 1.50022 14.9997H6.00012C6.56848 14.9997 7.08776 14.6789 7.34187 14.1706L9.00002 10.8543V16.483L11.9999 17.6079L14.9999 16.4827V10.8543L16.6581 14.1706C16.9122 14.6789 17.4315 14.9997 17.9998 14.9997H22.4997C23.328 14.9997 23.9997 14.328 23.9997 13.4997C23.9997 12.6714 23.3281 11.9998 22.4998 11.9998Z"
                                 fill="#C046D3"
                              />
                           </g>
                           <defs>
                              <clipPath id="clip5">
                                 <rect width={24} height={24} fill="white" />
                              </clipPath>
                           </defs>
                        </svg>
                        <div>
                           <h4 className="fs-18 text-black font-w600 mb-0">
                              86%
                           </h4>
                           <span className="fs-12 text-black">Yoga</span>
                        </div>
                     </div>
                     <Dropdown className="dropdown mt-sm-0 mt-3 mb-0">
                        <Dropdown.Toggle
                           variant=""
                           as="button"
                           className="btn rounded border border-light dropdown-toggle"
                        >
                           Weekly
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu-right">
                           <Dropdown.Item>Link 1</Dropdown.Item>
                           <Dropdown.Item>Link 2</Dropdown.Item>
                           <Dropdown.Item>Link 3</Dropdown.Item>
                        </Dropdown.Menu>
                     </Dropdown>
                  </div>
                  <div className="card-body pt-3">
                     <ApexLine4 />
                  </div>
               </div> */}
               {/* </div>
            <div className="col-xl-3 col-xxl-4 col-md-6">
               <div>
                  <table id='users'>
                     <thead>
                        <tr>
                           <th> id </th>
                           <th> shop name </th>
                        </tr>
                     </thead>
                     <tbody>
                        {shopsTableData()}
                     </tbody>
                  </table>
               </div> */}
               {/* <div className="card">
                  <div className="card-header border-0 pb-0">
                     <h4 className="text-black fs-20 mb-0">Workout Progress</h4>
                  </div>
                  <div className="card-body text-center">
                     <ApexRedialBar />
                     <p className="fs-14">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do{" "}
                     </p>
                     <Link
                        to="/workout-statistic"
                        className="btn btn-outline-primary rounded"
                     >
                        Set Target
                     </Link>
                  </div>
               </div> */}
               {/* </div>
            <div className="col-xl-3 col-xxl-4 col-md-6">
               <div className="card">
                  <div className="card-header border-0 pb-0">
                     <h4 className="text-black fs-20 mb-0">Duration Worked</h4>
                  </div>
                  <div className="card-body">
                     <div className="media align-items-center border border-warning rounded p-3 mb-md-4 mb-3">
                        <div className="d-inline-block mr-3 position-relative donut-chart-sale2">
                           <svg className="peity" height={70} width={70}>
                              <path
                                 d="M 35 0 A 35 35 0 1 1 0 35.00000000000001 L 8 35 A 27 27 0 1 0 35 8"
                                 data-value={6}
                                 fill="rgb(255, 148, 50)"
                              />
                              <path
                                 d="M 0 35.00000000000001 A 35 35 0 0 1 34.99999999999999 0 L 34.99999999999999 8 A 27 27 0 0 0 8 35"
                                 data-value={2}
                                 fill="rgba(255, 255, 255, 1)"
                              />
                           </svg>

                           <small className="text-primary">
                              <svg
                                 width={24}
                                 height={24}
                                 viewBox="0 0 24 24"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg"
                              >
                                 <g clipPath="url(#clip6)">
                                    <path
                                       d="M0.988926 17.074C0.328245 17.2006 -0.104616 17.8385 0.0219518 18.4992C0.133331 19.0814 0.644663 19.4864 1.21675 19.4864C1.29269 19.4864 1.37116 19.4788 1.4471 19.4636L6.45917 18.5017C6.74521 18.446 7.00087 18.2916 7.18313 18.0638L9.33478 15.3502L8.6159 14.9832C8.08432 14.7148 7.71471 14.2288 7.58815 13.639L5.55801 16.1982L0.988926 17.074Z"
                                       fill="#FF9432"
                                    />
                                    <path
                                       d="M18.84 6.493C20.3135 6.493 21.508 5.29848 21.508 3.82496C21.508 2.35144 20.3135 1.15692 18.84 1.15692C17.3664 1.15692 16.1719 2.35144 16.1719 3.82496C16.1719 5.29848 17.3664 6.493 18.84 6.493Z"
                                       fill="#FF9432"
                                    />
                                    <path
                                       d="M13.0179 3.15671C12.7369 2.86813 12.4762 2.75422 12.1902 2.75422C12.0863 2.75422 11.9826 2.76941 11.8712 2.79472L7.292 3.88067C6.65917 4.03002 6.26934 4.66539 6.41869 5.29569C6.54779 5.8374 7.02874 6.20192 7.56286 6.20192C7.65401 6.20192 7.74511 6.19179 7.83627 6.16901L11.7371 5.24507C11.9902 5.52605 13.2584 6.90057 13.4888 7.14358C11.8763 8.86996 10.2638 10.5938 8.65134 12.3202C8.62602 12.3481 8.60326 12.3759 8.58046 12.4037C8.10963 13.0036 8.25394 13.9453 8.96272 14.3022L13.9064 16.826L11.3396 20.985C10.9878 21.5571 11.165 22.3063 11.737 22.6607C11.937 22.7848 12.1572 22.843 12.3749 22.843C12.7825 22.843 13.1824 22.638 13.4128 22.2658L16.6732 16.9829C16.8529 16.6918 16.901 16.34 16.8073 16.0134C16.7137 15.6843 16.4884 15.411 16.1821 15.2565L12.8331 13.5529L16.3542 9.7863L19.0122 12.0392C19.2324 12.2265 19.5032 12.3176 19.7716 12.3176C20.0601 12.3176 20.3487 12.2113 20.574 12.0038L23.6242 9.16106C24.1002 8.71808 24.128 7.97386 23.685 7.49797C23.4521 7.24989 23.1382 7.12333 22.8243 7.12333C22.5383 7.12333 22.2497 7.22711 22.0244 7.43721L19.7412 9.56101C19.7386 9.56354 14.0178 4.1819 13.0179 3.15671Z"
                                       fill="#FF9432"
                                    />
                                 </g>
                                 <defs>
                                    <clipPath id="clip6">
                                       <rect
                                          width={24}
                                          height={24}
                                          fill="white"
                                       />
                                    </clipPath>
                                 </defs>
                              </svg>
                           </small>
                        </div>
                        <div>
                           <h4 className="fs-18 text-black mb-0">Running</h4>
                           <span className="fs-14 text-warning">
                              52 hours, 2min
                           </span>
                        </div>
                     </div>
                     <div className="media align-items-center border border-info rounded p-3 mb-md-4 mb-3">
                        <div className="d-inline-block mr-3 position-relative donut-chart-sale2">
                           <svg className="peity" height="70" width="70">
                              <path
                                 d="M 35 0 A 35 35 0 0 1 70 35 L 62 35 A 27 27 0 0 0 35 8"
                                 data-value="2"
                                 fill="rgb(30, 167, 197)"
                              ></path>
                              <path
                                 d="M 70 35 A 35 35 0 1 1 34.99999999999999 0 L 34.99999999999999 8 A 27 27 0 1 0 62 35"
                                 data-value="6"
                                 fill="rgba(255, 255, 255, 1)"
                              ></path>
                           </svg>
                           <small className="text-primary">
                              <svg
                                 width={24}
                                 height={24}
                                 viewBox="0 0 24 24"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg"
                              >
                                 <path
                                    d="M10.8586 5.22596L5.87121 10.5542C5.50758 11.0845 5.64394 11.8068 6.17172 12.1679L11.1945 15.6098V18.9558C11.1945 19.5921 11.6995 20.125 12.3359 20.1376C12.9874 20.1477 13.5177 19.6249 13.5177 18.976V15.0012C13.5177 14.6174 13.3283 14.2588 13.0126 14.0442L9.79041 11.8346L12.5025 8.95833L13.8914 12.1225C14.0758 12.5442 14.4949 12.8169 14.9546 12.8169H19.1844C19.8207 12.8169 20.3536 12.3119 20.3662 11.6755C20.3763 11.024 19.8536 10.4937 19.2046 10.4937H15.7172C15.2576 9.44821 14.7677 8.41285 14.3409 7.35225C14.1237 6.81689 14.0025 6.58457 13.6036 6.21588C13.5227 6.14013 12.9596 5.62498 12.4571 5.16538C11.995 4.74616 11.2828 4.77394 10.8586 5.22596Z"
                                    fill="#1EA7C5"
                                 />
                                 <path
                                    d="M15.6162 5.80678C17.0861 5.80678 18.2778 4.61514 18.2778 3.14517C18.2778 1.6752 17.0861 0.483551 15.6162 0.483551C14.1462 0.483551 12.9545 1.6752 12.9545 3.14517C12.9545 4.61514 14.1462 5.80678 15.6162 5.80678Z"
                                    fill="#1EA7C5"
                                 />
                                 <path
                                    d="M4.89899 23.5164C7.60463 23.5164 9.79798 21.323 9.79798 18.6174C9.79798 15.9117 7.60463 13.7184 4.89899 13.7184C2.19335 13.7184 0 15.9117 0 18.6174C0 21.323 2.19335 23.5164 4.89899 23.5164Z"
                                    fill="#1EA7C5"
                                 />
                                 <path
                                    d="M19.101 23.5164C21.8066 23.5164 24 21.323 24 18.6174C24 15.9117 21.8066 13.7184 19.101 13.7184C16.3954 13.7184 14.202 15.9117 14.202 18.6174C14.202 21.323 16.3954 23.5164 19.101 23.5164Z"
                                    fill="#1EA7C5"
                                 />
                              </svg>
                           </small>
                        </div>
                        <div>
                           <h4 className="fs-18 text-black mb-0">Cycling</h4>
                           <span className="fs-14 text-info">
                              23 hours, 45min
                           </span>
                        </div>
                     </div>
                     <div className="media align-items-center border border-secondary rounded p-3">
                        <div className="d-inline-block mr-3 position-relative donut-chart-sale2">
                           <svg className="peity" height={70} width={70}>
                              <path
                                 d="M 35 0 A 35 35 0 0 1 69.46827135542728 28.922313781657436 L 61.58980933132962 30.31149920299288 A 27 27 0 0 0 35 8"
                                 data-value={2}
                                 fill="rgb(192, 70, 211)"
                              />
                              <path
                                 d="M 69.46827135542728 28.922313781657436 A 35 35 0 1 1 34.99999999999999 0 L 34.99999999999999 8 A 27 27 0 1 0 61.58980933132962 30.31149920299288"
                                 data-value={7}
                                 fill="rgba(255, 255, 255, 1)"
                              />
                           </svg>

                           <small className="text-primary">
                              <svg
                                 width={24}
                                 height={24}
                                 viewBox="0 0 24 24"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg"
                              >
                                 <g clipPath="url(#clip7)">
                                    <path
                                       d="M11.9997 5.9999C13.6566 5.9999 14.9997 4.65677 14.9997 2.99995C14.9997 1.34312 13.6566 0 11.9997 0C10.3429 0 8.9998 1.34312 8.9998 2.99995C8.9998 4.65677 10.3429 5.9999 11.9997 5.9999Z"
                                       fill="#C046D3"
                                    />
                                    <path
                                       d="M17.8305 21.8297L14.1361 23.2153L15.9733 23.9042C16.764 24.1978 17.6171 23.791 17.9046 23.0261C18.0577 22.618 18.0124 22.1905 17.8305 21.8297Z"
                                       fill="#C046D3"
                                    />
                                    <path
                                       d="M5.02677 16.5949C4.25263 16.3078 3.3869 16.6974 3.09543 17.473C2.80467 18.2486 3.19799 19.1128 3.97354 19.4043L5.5918 20.0111L9.86412 18.4088L5.02677 16.5949Z"
                                       fill="#C046D3"
                                    />
                                    <path
                                       d="M20.9045 17.473C20.613 16.6974 19.7473 16.3078 18.9732 16.5949L6.97345 21.0948C6.19781 21.3863 5.80453 22.2505 6.0953 23.0262C6.38278 23.7908 7.23572 24.198 8.02664 23.9043L20.0264 19.4044C20.8021 19.1129 21.1953 18.2487 20.9045 17.473Z"
                                       fill="#C046D3"
                                    />
                                    <path
                                       d="M22.4998 11.9998H18.9271L16.3417 6.82899C16.073 6.29213 15.5265 5.98627 14.9632 5.99991L11.9997 5.9999L9.03663 5.99991C8.47343 5.98627 7.92757 6.29217 7.65828 6.82899L5.07289 11.9998H1.50022C0.671898 11.9998 0.000274658 12.6714 0.000274658 13.4997C0.000274658 14.328 0.671898 14.9997 1.50022 14.9997H6.00012C6.56848 14.9997 7.08776 14.6789 7.34187 14.1706L9.00002 10.8543V16.483L11.9999 17.6079L14.9999 16.4827V10.8543L16.6581 14.1706C16.9122 14.6789 17.4315 14.9997 17.9998 14.9997H22.4997C23.328 14.9997 23.9997 14.328 23.9997 13.4997C23.9997 12.6714 23.3281 11.9998 22.4998 11.9998Z"
                                       fill="#C046D3"
                                    />
                                 </g>
                                 <defs>
                                    <clipPath id="clip7">
                                       <rect
                                          width={24}
                                          height={24}
                                          fill="white"
                                       />
                                    </clipPath>
                                 </defs>
                              </svg>
                           </small>
                        </div>
                        <div>
                           <h4 className="fs-18 text-black mb-0">Yoga</h4>
                           <span className="fs-14 text-secondary">
                              16 hours, 2min
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div className="col-xl-9 col-xxl-8">
               <div className="card">
                  <div className="card-header d-sm-flex d-block pb-0 border-0">
                     <div className="mr-auto pr-3">
                        <h4 className="text-black fs-20">Calories Chart</h4>
                        <p className="fs-13 mb-0 text-black">
                           Lorem ipsum dolor sit amet, consectetur
                        </p>
                     </div>
                     <Dropdown className="dropdown mt-sm-0 mt-3">
                        <Dropdown.Toggle
                           as="button"
                           variant=""
                           className="btn rounded border border-light dropdown-toggle"
                        >
                           Weekly
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="dropdown-menu dropdown-menu-right">
                           <Dropdown.Item>Link 1</Dropdown.Item>
                           <Dropdown.Item>Link 2</Dropdown.Item>
                           <Dropdown.Item>Link 3</Dropdown.Item>
                        </Dropdown.Menu>
                     </Dropdown>
                  </div>
                  <div className="card-body">
                     <ApexNagetivePosative />
                  </div>
               </div>
            </div>
            <div className="col-xl-12">
               <div className="card">
                  <Tab.Container defaultActiveKey="breakfast">
                     <div className="card-header d-sm-flex d-block pb-0 border-0">
                        <div className="mr-auto pr-3">
                           <h4 className="text-black fs-20">
                              Featured Diet Menus
                           </h4>
                           <p className="fs-13 mb-0 text-black">
                              Lorem ipsum dolor sit amet, consectetur
                           </p>
                        </div>
                        <div className="card-action card-tabs mt-3 mt-sm-0 mt-3 mb-sm-0 mb-3 mt-sm-0">
                           <Nav as="ul" className="nav nav-tabs" role="tablist">
                              <Nav.Item className="nav-item">
                                 <Nav.Link
                                    data-toggle="tab"
                                    eventKey="breakfast"
                                 >
                                    Breakfast
                                 </Nav.Link>
                              </Nav.Item>
                              <Nav.Item className="nav-item">
                                 <Nav.Link eventKey="lunch">Lunch</Nav.Link>
                              </Nav.Item>
                              <Nav.Item className="nav-item">
                                 <Nav.Link eventKey="dinner">Dinner</Nav.Link>
                              </Nav.Item>
                           </Nav>
                        </div>
                        <Link
                           to="/diet-food-menu"
                           className="btn btn-primary rounded d-none d-lg-block ml-0 ml-md-5"
                        >
                           View More
                        </Link>
                     </div>
                     <div className="card-body fito-home-slider">
                        <Tab.Content className="tab-content">
                           <Tab.Pane role="tabpanel" eventKey="breakfast">
                              <div className="featured-menus owl-carousel">
                                 <Slider {...settings}>
                                    <div className="items">
                                       <div className="d-sm-flex p-3 border border-light rounded">
                                          <Link to="/ecom-product-detail">
                                             <img
                                                className="mr-4 food-image rounded"
                                                src={menu03}
                                                alt=""
                                                width={160}
                                             />
                                          </Link>
                                          <div>
                                             <div className="d-flex align-items-center mb-2">
                                                <img
                                                   className="rounded-circle mr-2 profile-image"
                                                   src={testimonial3}
                                                   alt=""
                                                   width={30}
                                                />
                                                <span className="fs-14 text-primary">
                                                   Ilham
                                                </span>
                                             </div>
                                             <h6 className="fs-16 mb-4">
                                                <Link
                                                   to="/ecom-product-detail"
                                                   className="text-black"
                                                >
                                                   Sweet Orange Fruits with
                                                   Lemon
                                                </Link>
                                             </h6>
                                             <ul>
                                                <li className="mb-2">
                                                   <i className="las la-clock scale5 mr-3" />
                                                   <span className="fs-14 text-black">
                                                      4-6 mins{" "}
                                                   </span>
                                                </li>
                                                <li>
                                                   <i
                                                      className="fa fa-star-o mr-3 scale5 text-warning"
                                                      aria-hidden="true"
                                                   />
                                                   <span className="fs-14 text-black font-w500">
                                                      176 Reviews
                                                   </span>
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>
                                    <div className="items">
                                       <div className="d-sm-flex p-3 border border-light rounded">
                                          <Link to="/ecom-product-detail">
                                             <img
                                                className="mr-4 food-image rounded"
                                                src={menu01}
                                                alt=""
                                                width={160}
                                             />
                                          </Link>
                                          <div>
                                             <div className="d-flex align-items-center mb-2">
                                                <img
                                                   className="rounded-circle mr-2 profile-image"
                                                   src={testimonial}
                                                   alt=""
                                                   width={30}
                                                />
                                                <span className="fs-14 text-primary">
                                                   Andrew
                                                </span>
                                             </div>
                                             <h6 className="fs-16 mb-4">
                                                <Link
                                                   to="/ecom-product-detail"
                                                   className="text-black"
                                                >
                                                   Fresh or Frozen (No Sugar
                                                   Added) Fruits
                                                </Link>
                                             </h6>
                                             <ul>
                                                <li className="mb-2">
                                                   <i className="las la-clock scale5 mr-3" />
                                                   <span className="fs-14 text-black">
                                                      4-6 mins{" "}
                                                   </span>
                                                </li>
                                                <li>
                                                   <i
                                                      className="fa fa-star-o mr-3 scale5 text-warning"
                                                      aria-hidden="true"
                                                   />
                                                   <span className="fs-14 text-black font-w500">
                                                      568 Reviews
                                                   </span>
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>

                                    <div className="items">
                                       <div className="d-sm-flex p-3 border border-light rounded">
                                          <Link to="/ecom-product-detail">
                                             <img
                                                className="mr-4 food-image rounded"
                                                src={menu01}
                                                alt=""
                                                width={160}
                                             />
                                          </Link>
                                          <div>
                                             <div className="d-flex align-items-center mb-2">
                                                <img
                                                   className="rounded-circle mr-2 profile-image"
                                                   src={testimonial}
                                                   alt=""
                                                   width={30}
                                                />
                                                <span className="fs-14 text-primary">
                                                   Andrew
                                                </span>
                                             </div>
                                             <h6 className="fs-16 mb-4">
                                                <Link
                                                   to="/ecom-product-detail"
                                                   className="text-black"
                                                >
                                                   Fresh or Frozen (No Sugar
                                                   Added) Fruits
                                                </Link>
                                             </h6>
                                             <ul>
                                                <li className="mb-2">
                                                   <i className="las la-clock scale5 mr-3" />
                                                   <span className="fs-14 text-black">
                                                      4-6 mins{" "}
                                                   </span>
                                                </li>
                                                <li>
                                                   <i
                                                      className="fa fa-star-o mr-3 scale5 text-warning"
                                                      aria-hidden="true"
                                                   />
                                                   <span className="fs-14 text-black font-w500">
                                                      568 Reviews
                                                   </span>
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>

                                    <div className="items">
                                       <div className="d-sm-flex p-3 border border-light rounded">
                                          <Link to="/ecom-product-detail">
                                             <img
                                                className="mr-4 food-image rounded"
                                                src={menu02}
                                                alt=""
                                                width={160}
                                             />
                                          </Link>
                                          <div>
                                             <div className="d-flex align-items-center mb-2">
                                                <img
                                                   className="rounded-circle mr-2 profile-image"
                                                   src={testimonial2}
                                                   alt=""
                                                   width={30}
                                                />
                                                <span className="fs-14 text-primary">
                                                   Chintya
                                                </span>
                                             </div>
                                             <h6 className="fs-16 mb-4">
                                                <Link
                                                   to="/ecom-product-detail"
                                                   className="text-black"
                                                >
                                                   Chicken Egg with fresh
                                                   tomatos
                                                </Link>
                                             </h6>
                                             <ul>
                                                <li className="mb-2">
                                                   <i className="las la-clock scale5 mr-3" />
                                                   <span className="fs-14 text-black">
                                                      4-6 mins{" "}
                                                   </span>
                                                </li>
                                                <li>
                                                   <i
                                                      className="fa fa-star-o mr-3 scale5 text-warning"
                                                      aria-hidden="true"
                                                   />
                                                   <span className="fs-14 text-black font-w500">
                                                      223 Reviews
                                                   </span>
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>
                                 </Slider>
                              </div>
                           </Tab.Pane>
                           <Tab.Pane
                              // className={`tab-pane fade ${
                              //    activeToggle === "lunch" ? "active show" : ""
                              // }`}
                              id="Lunch"
                              role="tabpanel"
                              eventKey="lunch"
                           >
                              <div className="featured-menus owl-carousel">
                                 <Slider {...settings}>
                                    <div className="items">
                                       <div className="d-sm-flex p-3 border border-light rounded">
                                          <Link to="/ecom-product-detail">
                                             <img
                                                className="mr-4 food-image rounded"
                                                src={menu01}
                                                alt=""
                                                width={160}
                                             />
                                          </Link>
                                          <div>
                                             <div className="d-flex align-items-center mb-2">
                                                <img
                                                   className="rounded-circle mr-2 profile-image"
                                                   src={testimonial}
                                                   alt=""
                                                   width={30}
                                                />
                                                <span className="fs-14 text-primary">
                                                   Andrew
                                                </span>
                                             </div>
                                             <h6 className="fs-16 mb-4">
                                                <Link
                                                   to="/ecom-product-detail"
                                                   className="text-black"
                                                >
                                                   Fresh or Frozen (No Sugar
                                                   Added) Fruits
                                                </Link>
                                             </h6>
                                             <ul>
                                                <li className="mb-2">
                                                   <i className="las la-clock scale5 mr-3" />
                                                   <span className="fs-14 text-black">
                                                      4-6 mins{" "}
                                                   </span>
                                                </li>
                                                <li>
                                                   <i
                                                      className="fa fa-star-o mr-3 scale5 text-warning"
                                                      aria-hidden="true"
                                                   />
                                                   <span className="fs-14 text-black font-w500">
                                                      568 Reviews
                                                   </span>
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>
                                    <div className="items">
                                       <div className="d-sm-flex p-3 border border-light rounded">
                                          <Link to="/ecom-product-detail">
                                             <img
                                                className="mr-4 food-image rounded"
                                                src={menu03}
                                                alt=""
                                                width={160}
                                             />
                                          </Link>
                                          <div>
                                             <div className="d-flex align-items-center mb-2">
                                                <img
                                                   className="rounded-circle mr-2 profile-image"
                                                   src={testimonial3}
                                                   alt=""
                                                   width={30}
                                                />
                                                <span className="fs-14 text-primary">
                                                   Ilham
                                                </span>
                                             </div>
                                             <h6 className="fs-16 mb-4">
                                                <Link
                                                   to="/ecom-product-detail"
                                                   className="text-black"
                                                >
                                                   Sweet Orange Fruits with
                                                   Lemon
                                                </Link>
                                             </h6>
                                             <ul>
                                                <li className="mb-2">
                                                   <i className="las la-clock scale5 mr-3" />
                                                   <span className="fs-14 text-black">
                                                      4-6 mins{" "}
                                                   </span>
                                                </li>
                                                <li>
                                                   <i
                                                      className="fa fa-star-o mr-3 scale5 text-warning"
                                                      aria-hidden="true"
                                                   />
                                                   <span className="fs-14 text-black font-w500">
                                                      176 Reviews
                                                   </span>
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>
                                    <div className="items">
                                       <div className="d-sm-flex p-3 border border-light rounded">
                                          <Link to="/ecom-product-detail">
                                             <img
                                                className="mr-4 food-image rounded"
                                                src={menu02}
                                                alt=""
                                                width={160}
                                             />
                                          </Link>
                                          <div>
                                             <div className="d-flex align-items-center mb-2">
                                                <img
                                                   className="rounded-circle mr-2 profile-image"
                                                   src={testimonial2}
                                                   alt=""
                                                   width={30}
                                                />
                                                <span className="fs-14 text-primary">
                                                   Chintya
                                                </span>
                                             </div>
                                             <h6 className="fs-16 mb-4">
                                                <Link
                                                   to="/ecom-product-detail"
                                                   className="text-black"
                                                >
                                                   Chicken Egg with fresh
                                                   tomatos
                                                </Link>
                                             </h6>
                                             <ul>
                                                <li className="mb-2">
                                                   <i className="las la-clock scale5 mr-3" />
                                                   <span className="fs-14 text-black">
                                                      4-6 mins{" "}
                                                   </span>
                                                </li>
                                                <li>
                                                   <i
                                                      className="fa fa-star-o mr-3 scale5 text-warning"
                                                      aria-hidden="true"
                                                   />
                                                   <span className="fs-14 text-black font-w500">
                                                      223 Reviews
                                                   </span>
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>
                                    <div className="items">
                                       <div className="d-sm-flex p-3 border border-light rounded">
                                          <Link to="/ecom-product-detail">
                                             <img
                                                className="mr-4 food-image rounded"
                                                src={menu01}
                                                alt=""
                                                width={160}
                                             />
                                          </Link>
                                          <div>
                                             <div className="d-flex align-items-center mb-2">
                                                <img
                                                   className="rounded-circle mr-2 profile-image"
                                                   src={testimonial}
                                                   alt=""
                                                   width={30}
                                                />
                                                <span className="fs-14 text-primary">
                                                   Andrew
                                                </span>
                                             </div>
                                             <h6 className="fs-16 mb-4">
                                                <Link
                                                   to="/ecom-product-detail"
                                                   className="text-black"
                                                >
                                                   Fresh or Frozen (No Sugar
                                                   Added) Fruits
                                                </Link>
                                             </h6>
                                             <ul>
                                                <li className="mb-2">
                                                   <i className="las la-clock scale5 mr-3" />
                                                   <span className="fs-14 text-black">
                                                      4-6 mins{" "}
                                                   </span>
                                                </li>
                                                <li>
                                                   <i
                                                      className="fa fa-star-o mr-3 scale5 text-warning"
                                                      aria-hidden="true"
                                                   />
                                                   <span className="fs-14 text-black font-w500">
                                                      568 Reviews
                                                   </span>
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>
                                 </Slider>
                              </div>
                           </Tab.Pane>
                           <Tab.Pane
                              // className={`tab-pane fade ${
                              //    activeToggle === "dinner" ? "active show" : ""
                              // }`}
                              id="Dinner"
                              role="tabpanel"
                              eventKey="dinner"
                           >
                              <div className="featured-menus owl-carousel">
                                 <Slider {...settings}>
                                    <div className="items">
                                       <div className="d-sm-flex p-3 border border-light rounded">
                                          <Link to="/ecom-product-detail">
                                             <img
                                                className="mr-4 food-image rounded"
                                                src={menu01}
                                                alt=""
                                                width={160}
                                             />
                                          </Link>
                                          <div>
                                             <div className="d-flex align-items-center mb-2">
                                                <img
                                                   className="rounded-circle mr-2 profile-image"
                                                   src={testimonial}
                                                   alt=""
                                                   width={30}
                                                />
                                                <span className="fs-14 text-primary">
                                                   Andrew
                                                </span>
                                             </div>
                                             <h6 className="fs-16 mb-4">
                                                <Link
                                                   to="/ecom-product-detail"
                                                   className="text-black"
                                                >
                                                   Fresh or Frozen (No Sugar
                                                   Added) Fruits
                                                </Link>
                                             </h6>
                                             <ul>
                                                <li className="mb-2">
                                                   <i className="las la-clock scale5 mr-3" />
                                                   <span className="fs-14 text-black">
                                                      4-6 mins{" "}
                                                   </span>
                                                </li>
                                                <li>
                                                   <i
                                                      className="fa fa-star-o mr-3 scale5 text-warning"
                                                      aria-hidden="true"
                                                   />
                                                   <span className="fs-14 text-black font-w500">
                                                      568 Reviews
                                                   </span>
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>
                                    <div className="items">
                                       <div className="d-sm-flex p-3 border border-light rounded">
                                          <Link to="/ecom-product-detail">
                                             <img
                                                className="mr-4 food-image rounded"
                                                src={menu02}
                                                alt=""
                                                width={160}
                                             />
                                          </Link>
                                          <div>
                                             <div className="d-flex align-items-center mb-2">
                                                <img
                                                   className="rounded-circle mr-2 profile-image"
                                                   src={testimonial2}
                                                   alt=""
                                                   width={30}
                                                />
                                                <span className="fs-14 text-primary">
                                                   Chintya
                                                </span>
                                             </div>
                                             <h6 className="fs-16 mb-4">
                                                <Link
                                                   to="/ecom-product-detail"
                                                   className="text-black"
                                                >
                                                   Chicken Egg with fresh
                                                   tomatos
                                                </Link>
                                             </h6>
                                             <ul>
                                                <li className="mb-2">
                                                   <i className="las la-clock scale5 mr-3" />
                                                   <span className="fs-14 text-black">
                                                      4-6 mins{" "}
                                                   </span>
                                                </li>
                                                <li>
                                                   <i
                                                      className="fa fa-star-o mr-3 scale5 text-warning"
                                                      aria-hidden="true"
                                                   />
                                                   <span className="fs-14 text-black font-w500">
                                                      223 Reviews
                                                   </span>
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>
                                    <div className="items">
                                       <div className="d-sm-flex p-3 border border-light rounded">
                                          <Link to="/ecom-product-detail">
                                             <img
                                                className="mr-4 food-image rounded"
                                                src={menu03}
                                                alt=""
                                                width={160}
                                             />
                                          </Link>
                                          <div>
                                             <div className="d-flex align-items-center mb-2">
                                                <img
                                                   className="rounded-circle mr-2 profile-image"
                                                   src={testimonial3}
                                                   alt=""
                                                   width={30}
                                                />
                                                <span className="fs-14 text-primary">
                                                   Ilham
                                                </span>
                                             </div>
                                             <h6 className="fs-16 mb-4">
                                                <Link
                                                   to="/ecom-product-detail"
                                                   className="text-black"
                                                >
                                                   Sweet Orange Fruits with
                                                   Lemon
                                                </Link>
                                             </h6>
                                             <ul>
                                                <li className="mb-2">
                                                   <i className="las la-clock scale5 mr-3" />
                                                   <span className="fs-14 text-black">
                                                      4-6 mins{" "}
                                                   </span>
                                                </li>
                                                <li>
                                                   <i
                                                      className="fa fa-star-o mr-3 scale5 text-warning"
                                                      aria-hidden="true"
                                                   />
                                                   <span className="fs-14 text-black font-w500">
                                                      176 Reviews
                                                   </span>
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>
                                    <div className="items">
                                       <div className="d-sm-flex p-3 border border-light rounded">
                                          <Link to="/ecom-product-detail">
                                             <img
                                                className="mr-4 food-image rounded"
                                                src={menu01}
                                                alt=""
                                                width={160}
                                             />
                                          </Link>
                                          <div>
                                             <div className="d-flex align-items-center mb-2">
                                                <img
                                                   className="rounded-circle mr-2 profile-image"
                                                   src={testimonial}
                                                   alt=""
                                                   width={30}
                                                />
                                                <span className="fs-14 text-primary">
                                                   Andrew
                                                </span>
                                             </div>
                                             <h6 className="fs-16 mb-4">
                                                <Link
                                                   to="/ecom-product-detail"
                                                   className="text-black"
                                                >
                                                   Fresh or Frozen (No Sugar
                                                   Added) Fruits
                                                </Link>
                                             </h6>
                                             <ul>
                                                <li className="mb-2">
                                                   <i className="las la-clock scale5 mr-3" />
                                                   <span className="fs-14 text-black">
                                                      4-6 mins{" "}
                                                   </span>
                                                </li>
                                                <li>
                                                   <i
                                                      className="fa fa-star-o mr-3 scale5 text-warning"
                                                      aria-hidden="true"
                                                   />
                                                   <span className="fs-14 text-black font-w500">
                                                      568 Reviews
                                                   </span>
                                                </li>
                                             </ul>
                                          </div>
                                       </div>
                                    </div>
                                 </Slider>
                              </div>
                           </Tab.Pane>
                        </Tab.Content>
                     </div>
                  </Tab.Container>
               </div> */}
               {/* </div> */}


            </div>
      }

      </>
   );
};

export default Home;
